export const RESULT_TIME_TITLE_SKELETON_WIDTH = {
  mobile: 200,
  desktop: 550,
};

export const RESULT_TIME_TITLE_SKELETON_HEIGHT = 50;
